import { render, staticRenderFns } from "./LaudoCarbono.vue?vue&type=template&id=4e3b5f7a&scoped=true&lang=pug"
import script from "./LaudoCarbono.vue?vue&type=script&lang=js"
export * from "./LaudoCarbono.vue?vue&type=script&lang=js"
import style0 from "./LaudoCarbono.vue?vue&type=style&index=0&id=4e3b5f7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b5f7a",
  null
  
)

export default component.exports